import { consoleLog } from './consoleLog.ts'

consoleLog("Welcome to Is Fox theme!")
